import IntegrationCallListResourcePagingResultModel from '../../generated/types/model/resource/IntegrationCallListResourcePagingResultModel';

export default class IntegrationCallListResourcePagingResultViewModel extends IntegrationCallListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
